import { OnInit, Component, Optional, Inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { EventEmitterService } from '../../../../services/EventEmitterService.component';
import { Subscription } from 'rxjs';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { PcfService } from '../../../../services/PcfService.component';
import { NxiRestService } from '../../../../services/NXI-Rest.service';
import { PershingTranslationService } from '@pershing/pershing-core';
interface TestObject {
    name: string;
    value: string;
}

@Component({
    selector: 'Maturity-Schedule-Filter',
    templateUrl: './MaturityScheduleFilter.component.html',
    styleUrls: ['./MaturityScheduleFilter.component.css']
})

export class MaturityScheduleFilter implements OnInit {
    timeArray: TestObject[]= [{name: 'All', value: '0'},
                {name: 'Next Week', value: '1'},
                {name: 'Next Two Weeks', value: '2'},
                {name: 'Next Three Weeks', value: '3'},
                {name: 'Next 1 Month', value: '4'},
                {name: 'Next 2 Months', value: '5'},
                {name: 'Next 3 Months', value: '6'},
                {name: 'Next 6 Months', value: '7'},
                {name: 'Next 9 Months', value: '8'},
                {name: 'Next 1 Year', value: '9'}
            ];
    da: any;
    timePeriod = '6';
    subs: Subscription;
    acctRef: any;
    isDisabled: Boolean = false;
    serviceUrl: any;
    ismobile: boolean = false;
    isAda: boolean = false;
    showf: boolean = false;
    params: any;
    error: any;
    constructor(private ee: EventEmitterService, private contextService: IContextService, private pcfservice: PcfService, private nxiRestService: NxiRestService,
                private translationService: PershingTranslationService, @Optional() @Inject('AppSettings') appSettings: any) {
                this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
                if (appSettings.deviceType === 'mobile') {
                    this.ismobile = true;
                 }
                if (appSettings.themeType === 'ada') {
                    this.isAda = true;
                }
                }
    ngOnInit() {
        this.serviceUrl = this.nxiRestService.serviceUrl;
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.acctRef = contextValue.hashValue;
            this.applyFilter();
        });
    }
    applyFilter() {
         this.params = new HttpParams()
            .set('maturityTimePeriod', this.timePeriod)
            .set('isGDR', 'true');
         this.pcfservice.Maturityschedule(this.serviceUrl, this.acctRef, this.params).subscribe(
            data => {
                this.da = data;
                this.ee.emitdata(this.da);
            },
            err => {
                console.error(err);
                this.error = err;
            },
            () => console.log('data recieved')
        );
    }
    showFilter() {
        this.showf = ! this.showf;
    }

}
